module.exports = __webpack_public_path__ + "static/media/eg8.ef40869a.webp";